import { toast } from '@etherisc/ui-kit';
import { ShapefileRouter } from '../../components/shapefile';
import { ShapefileManagement } from './ShapefileManagement';
import { shapefileService } from '../../services/climate/spatial/ShapefileService';
import type { Shapefile } from '../../types/shapefile';

export function ShapefileManagementPage() {
  const showSuccess = (message: string, description?: string) => toast.success(message, { description });
  const showError = (message: string, description?: string) => toast.error(message, { description });

  const handleDownload = async (shapefile: Shapefile) => {
    try {
      const blob = await shapefileService.downloadShapefile(shapefile.id);
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${shapefile.filename}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      showSuccess('Download Started', `Downloading "${shapefile.name}"`);
    } catch (error) {
      console.error('Error downloading shapefile:', error);
      const errorMessage = error instanceof Error ? error.message : 'Failed to download shapefile.';
      showError('Download Failed', errorMessage);
    }
  };

  return (
    <ShapefileRouter
      onDownload={handleDownload}
      renderList={(onViewDetails) => (
        <ShapefileManagement onViewDetails={onViewDetails} />
      )}
    />
  );
} 